Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.CompressionAlgorithm = module.exports.default = {
	DEFLATE: "deflate",
	//GZIP;
	LZMA: "lzma",
	ZLIB: "zlib"
};